export default class FacebookLogin {
  static checkFacebookLoginState () {
    return new Promise((resolve, reject) => {
      window.FB.getLoginStatus(function (response) {
        resolve(response)
      })
    })
  }

  static loginFacebook () {
    return new Promise((resolve, reject) => {
      window.FB.login(function (response) {
        resolve(response)
      })
    })
  }

  static logoutFacebook () {
    return new Promise((resolve, reject) => {
      window.FB.logout(function (response) {
        resolve(response)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/lib/facebookLogin.js